import emailjs from "emailjs-com";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import pdf_es from "../data/terminos&condiciones2023.pdf";
import pdf_eu from "../data/terms&conditions2023.pdf";
import { MotionReveal } from "./landing/MotionReveal";

const initialState = { name: "", email: "", message: "" };

const CONTACT = {
  phone: "+57 322 6873276",
  email: "info@orlyvisions.com",
  facebook: "https://www.facebook.com/profile.php?id=61586788535322",
  youtube: "https://www.youtube.com/@SIAT_ALERT",
};

export const Contact = (props) => {
  const { t, i18n } = useTranslation("global");
  const currentLang = i18n.language;
  const [state, setState] = useState(initialState);

  const phone = props.data?.phone || t("contact.phone") || CONTACT.phone;
  const email =
    props.data?.email || t("contact.emailAddress") || CONTACT.email;
  const facebook =
    props.data?.facebook || t("contact.facebook") || CONTACT.facebook;
  const youtube =
    props.data?.youtube || t("contact.youtube") || CONTACT.youtube;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", e.target, "YOUR_USER_ID")
      .then(
        () => clearState(),
        () => {}
      );
  };

  return (
    <section className="siat-contact-band" id="contact">
      <div className="siat-shell">
        <MotionReveal className="siat-contact-band__intro">
          <p className="siat-kicker">{t("navigation.contact")}</p>
          <h2>{t("contact.con")}</h2>
          <p className="siat-lede">{t("contact.complete")}</p>
        </MotionReveal>

        <div className="siat-contact-band__grid">
          <MotionReveal className="siat-contact-band__form">
            <form
              className="siat-form"
              name="sentMessage"
              onSubmit={handleSubmit}
            >
              <div className="siat-form__row">
                <label className="siat-field" htmlFor="name">
                  <span>{t("contact.name")}</span>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={state.name}
                    autoComplete="name"
                    required
                    onChange={handleChange}
                  />
                </label>
                <label className="siat-field" htmlFor="email">
                  <span>{t("contact.email")}</span>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={state.email}
                    autoComplete="email"
                    required
                    onChange={handleChange}
                  />
                </label>
              </div>

              <label className="siat-field" htmlFor="message">
                <span>{t("contact.message")}</span>
                <textarea
                  name="message"
                  id="message"
                  rows="4"
                  value={state.message}
                  required
                  onChange={handleChange}
                />
              </label>

              <div className="siat-form__actions">
                <button type="submit" className="siat-btn siat-btn--primary">
                  {t("contact.send")}
                </button>
                <button
                  type="button"
                  onClick={() => (window.location = "delete_data")}
                  className="siat-form__delete"
                >
                  {t("contact.deleteAccount")}
                </button>
              </div>
            </form>
          </MotionReveal>

          <aside className="siat-contact-band__aside">
            <a
              className="siat-contact-chip"
              href={`tel:${phone.replace(/\s/g, "")}`}
            >
              <span>{t("contact.tel")}</span>
              <strong>{phone}</strong>
            </a>
            <a className="siat-contact-chip" href={`mailto:${email}`}>
              <span>{t("contact.email")}</span>
              <strong>{email}</strong>
            </a>
            <a
              className="siat-contact-chip siat-contact-chip--social"
              href={facebook}
              target="_blank"
              rel="noreferrer"
            >
              <span>Facebook</span>
              <strong>Orly Visions</strong>
            </a>
            <a
              className="siat-contact-chip siat-contact-chip--social"
              href={youtube}
              target="_blank"
              rel="noreferrer"
            >
              <span>YouTube</span>
              <strong>@SIAT_ALERT</strong>
            </a>
          </aside>
        </div>
      </div>

      <footer className="siat-legal">
        <p>
          &copy; {new Date().getFullYear()} SIAT.{" "}
          <a
            href={currentLang === "es" ? pdf_es : pdf_eu}
            target="_blank"
            rel="noreferrer"
          >
            {t("terms")}
          </a>
          {" — "}
          <Link to="/privacy">{t("privacy")}</Link>
        </p>
      </footer>
    </section>
  );
};
